import {appUrls} from "../helpers/Urls";
import axiosInstance from "utils/axiosInstance";

export function HypoInfoApi() {
  const fetchData = async (patientId,daysAgo) => {
    let LogData= await axiosInstance.get(appUrls.hypoData(patientId,daysAgo));
    return LogData.data;
  };
  return fetchData;
};

export const HypoInfoListApi = () => {
  const fetchData = async (patientId, daysAgo) => {
    let LogData= await axiosInstance.get(appUrls.hypoListData(patientId,daysAgo,2));
    return LogData?.data;
  };
  return fetchData;
};
